import SignsPage from "./signs";

export default SignsPage;